"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectBaseStyles = void 0;
var _react = require("@emotion/react");
var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var selectBaseStyles = (0, _react.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    --select-icon-height: 12px;\n\n    .MuiInputLabel-root {\n        &.Mui-focused:not(.MuiFormLabel-filled) {\n            transform: translate(12px, 14.5px) scale(1);\n        }\n    }\n\n    &.--no-label {\n        .MuiSelect-select {\n            padding-top: 16px;\n            padding-bottom: 16px;\n        }\n    }\n\n    .MuiSelect-icon {\n        top: calc(50% - var(--select-icon-height) / 2);\n        right: 12px;\n    }\n"])));
exports.selectBaseStyles = selectBaseStyles;